// Vuex Departments module actions
import { API } from '@/config';

import {
  FILL_LIST, TOGGLE_AGENT_IN_DEPARTMENT,
} from './mutations-types';

export default {
  async getList({ commit }) {
    try {
      const list = (await API.get('/departments')).data.data;
      commit(FILL_LIST, { list });
    } catch (error) {
      console.log(error);
    }
  },

  async create(context, newDepartment) {
    try {
      const params = { ...newDepartment };
      await API.put('/department', params);
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },

  async update(context, params) {
    try {
      await API.post('/department', params);
    } catch (error) {
      console.log(error);
    }
  },

  async delete(context, id) {
    try {
      await API.delete(`/department?id=${id}`);
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },

  async assignAgent({ commit }, params) {
    try {
      const { department, agent } = params;
      await API.put('/department/assignAgent', { department, agent });
      commit(TOGGLE_AGENT_IN_DEPARTMENT, params);
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },

  async unassignAgent({ commit }, params) {
    try {
      const { department, agent } = params;
      await API.delete(`/department/unassignAgent?agent=${agent}&department=${department}`);
      commit(TOGGLE_AGENT_IN_DEPARTMENT, params);
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  },
};
